import React, { useState } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { useDeployEvents } from "./DeployEventContext"

const MONO = "var(--app-font-mono)"

export default function DeployBanner() {
  const { deployState } = useDeployEvents()
  const [dismissedId, setDismissedId] = useState(null)

  if (deployState.status === "cancelled" && deployState.id && deployState.id !== dismissedId) {
    return (
      <Box sx={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
        background: "rgba(239,68,68,0.12)", borderBottom: "1px solid rgba(239,68,68,0.35)",
        display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, py: 0.5, px: 2,
        backdropFilter: "blur(4px)",
      }}>
        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "var(--app-error)", flexShrink: 0 }} />
        <Typography sx={{ fontSize: "0.75rem", color: "var(--app-error)", fontFamily: MONO, letterSpacing: "0.05em" }}>
          {deployState.cancelled_by
            ? `Deploy abgebrochen von ${deployState.cancelled_by}`
            : "Deploy abgebrochen (Timeout)"}
          {deployState.cancel_note ? ` — „${deployState.cancel_note}"` : ""}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={() => setDismissedId(deployState.id)}
          sx={{
            fontSize: "0.65rem", fontFamily: MONO, color: "var(--app-error)",
            borderColor: "rgba(239,68,68,0.5)", textTransform: "none", py: 0.1, px: 1, minWidth: 0,
            "&:hover": { borderColor: "var(--app-error)", bgcolor: "rgba(239,68,68,0.1)" },
          }}
        >
          OK
        </Button>
      </Box>
    )
  }

  if (deployState.status === "building") {
    return (
      <Box sx={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
        background: "rgba(234,179,8,0.12)", borderBottom: "1px solid rgba(234,179,8,0.35)",
        display: "flex", alignItems: "center", justifyContent: "center", gap: 1, py: 0.6,
        backdropFilter: "blur(4px)",
      }}>
        <Box sx={{
          width: 8, height: 8, borderRadius: "50%", bgcolor: "var(--app-warning)",
          animation: "pulse 1.2s ease-in-out infinite",
          "@keyframes pulse": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.3 } },
        }} />
        <Typography sx={{ fontSize: "0.75rem", color: "var(--app-warning)", fontFamily: MONO, letterSpacing: "0.05em" }}>
          Building and deploying — a reload will be required soon
        </Typography>
      </Box>
    )
  }

  if (deployState.status === "complete") {
    return (
      <Box sx={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
        background: "rgba(34,197,94,0.12)", borderBottom: "1px solid rgba(34,197,94,0.35)",
        display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, py: 0.5,
        backdropFilter: "blur(4px)",
      }}>
        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "var(--app-success)", flexShrink: 0 }} />
        <Typography sx={{ fontSize: "0.75rem", color: "var(--app-success)", fontFamily: MONO, letterSpacing: "0.05em" }}>
          Update complete — please reload to apply
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={() => window.location.reload()}
          sx={{
            fontSize: "0.65rem", fontFamily: MONO, color: "var(--app-success)",
            borderColor: "rgba(34,197,94,0.5)", textTransform: "none", py: 0.1, px: 1, minWidth: 0,
            "&:hover": { borderColor: "var(--app-success)", bgcolor: "rgba(34,197,94,0.1)" },
          }}
        >
          Reload
        </Button>
      </Box>
    )
  }

  return null
}
